(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu functionality
  const mobileToggle = document.querySelector('[data-toggle-mobile-menu]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  const closeButton = document.querySelector('[data-close-mobile-menu]');
  
  if (mobileToggle && mobileMenu && mobileOverlay && closeButton) {
    // Open mobile menu
    mobileToggle.addEventListener('click', function() {
      mobileMenu.classList.add('active');
      mobileOverlay.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent scrolling when menu is open
    });
    
    // Close mobile menu function
    function closeMobileMenu() {
      mobileMenu.classList.remove('active');
      mobileOverlay.classList.remove('active');
      document.body.style.overflow = ''; // Restore scrolling
    }
    
    // Close mobile menu with close button
    closeButton.addEventListener('click', closeMobileMenu);
    
    // Close mobile menu when clicking on overlay
    mobileOverlay.addEventListener('click', closeMobileMenu);
    
    // Close mobile menu when clicking on a menu item
    const menuLinks = document.querySelectorAll('.custom-header__mobile-menu-link');
    menuLinks.forEach(function(link) {
      link.addEventListener('click', closeMobileMenu);
    });
    
    // Close mobile menu on window resize (if screen becomes desktop size)
    window.addEventListener('resize', function() {
      if (window.innerWidth > 991) {
        closeMobileMenu();
      }
    });
    
    // Handle escape key to close menu
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && mobileMenu.classList.contains('active')) {
        closeMobileMenu();
      }
    });
  }
  
  // Add sticky header effect with smooth transition
  let lastScrollTop = 0;
  const header = document.querySelector('.custom-header');
  
  window.addEventListener('scroll', function() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > lastScrollTop && scrollTop > 150) {
      // Scrolling down & past threshold
      header.style.transform = 'translateY(-100%)';
      header.style.transition = 'transform 0.3s ease-in-out';
    } else {
      // Scrolling up
      header.style.transform = 'translateY(0)';
      header.style.transition = 'transform 0.3s ease-in-out';
    }
    
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonial-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // For lazy loading videos
  const videoWrappers = document.querySelectorAll('.video-wrapper');
  
  if (videoWrappers.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const iframe = entry.target.querySelector('iframe');
          if (iframe && iframe.dataset.src) {
            iframe.src = iframe.dataset.src;
            iframe.removeAttribute('data-src');
          }
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    
    videoWrappers.forEach(wrapper => {
      observer.observe(wrapper);
    });
  }
  
  // For playing video when in viewport
  const videos = document.querySelectorAll('.custom-video-player');
  
  if (videos.length > 0) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting) {
          // Optional: autoplay when in view
          // video.play();
        } else {
          if (!video.paused) {
            video.pause();
          }
        }
      });
    }, { threshold: 0.5 });
    
    videos.forEach(video => {
      videoObserver.observe(video);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
